var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0835 9.41762V0.582469C1.0835 0.26078 1.34428 0 1.66597 0H8.37913C8.70082 0 8.9616 0.26078 8.9616 0.582469V9.41762C8.9616 9.88191 8.44405 10.1587 8.05781 9.90124L5.34351 8.09183C5.14911 7.96236 4.89599 7.96236 4.70159 8.09183L1.98729 9.90124C1.60104 10.1591 1.0835 9.88191 1.0835 9.41762Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIcon);
export default __webpack_public_path__ + "static/media/BookmarkIcon.0979564d4e5e11ac31cefe5c69e9cfd0.svg";
export { ForwardRef as ReactComponent };